import MuiKeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type KeyboardArrowLeftProps = SvgIconProps;

export const KeyboardArrowLeft = (props: KeyboardArrowLeftProps) => {
  return <MuiKeyboardArrowLeft {...props} />;
};
